import { call } from "redux-saga/effects";

import { ApiService, dictionaryApiService, authApiService, notificationApiService } from "../../../../api/actionService/apiService";

import { ApiCallResult } from "../../../../api/types";

import { DICTIONARY_API_SETTINGS_CONTROLLER_END_POINTS } from "../../../../config/apiEndPoints/DictionaryApiEndsPoints/SettingsController";
import { AUTH_API_CONTROLLER_END_POINTS } from "../../../../config/apiEndPoints/AuthApiEndPoints/AuthController";
import { NOTIFICATION_API_FEEDBACK_CONTROLLER_END_POINTS } from "../../../../config/apiEndPoints/NotificationApiEndPoints/FeedbackController";
import { AdditionalJobModel } from "../../../../viewModels/Settings/AdditionalJobModel";
import { DICTIONARY_API_ADDITIONAL_JOBS_CONTROLLER_END_POINTS } from "../../../../config/apiEndPoints/DictionaryApiEndsPoints/AdditionalJobsController";
import { DICTIONARY_API_CARRIERS_CONTROLLER_END_POINTS } from "../../../../config/apiEndPoints/DictionaryApiEndsPoints/CarriersController";

const dictionaryController = DICTIONARY_API_SETTINGS_CONTROLLER_END_POINTS.CONTROLLER_PATH;
const authController = AUTH_API_CONTROLLER_END_POINTS.CONTROLLER_PATH;
const notificationFeedbackController = NOTIFICATION_API_FEEDBACK_CONTROLLER_END_POINTS.CONTROLLER_PATH;

const feedbackPath = `${notificationFeedbackController}${NOTIFICATION_API_FEEDBACK_CONTROLLER_END_POINTS.FEEDBACK_PATH}`;

const additionalJobsPath = DICTIONARY_API_ADDITIONAL_JOBS_CONTROLLER_END_POINTS.CONTROLLER_PATH;

const loginBitrixPath = `${authController}${AUTH_API_CONTROLLER_END_POINTS.LOGIN_BITRIX}`;

const carriersController = DICTIONARY_API_CARRIERS_CONTROLLER_END_POINTS.CONTROLLER_PATH;
const digitalLogistCarriersBasicInfoPath = `${carriersController}${DICTIONARY_API_CARRIERS_CONTROLLER_END_POINTS.BASIC_INFO}`;

export class GlobalHttpService {
  private dictionaryApiService: ApiService;

  private authApiService: ApiService;

  private notificationApiService: ApiService;

  constructor(passedDictionaryApiService: ApiService, passedAuthApiService: ApiService, passedNotificationApiService: ApiService) {
    this.dictionaryApiService = passedDictionaryApiService;
    this.authApiService = passedAuthApiService;
    this.notificationApiService = passedNotificationApiService;
  }

  public *GetSettings() {
    return (yield call([this.dictionaryApiService, this.dictionaryApiService.Get], dictionaryController)) as ApiCallResult;
  }

  public *GetUser() {
    return (yield call([this.authApiService, this.authApiService.Get], authController)) as ApiCallResult;
  }

  public *SendFeedbackForm(fullname: string, phoneNumber: string, email: string, message: string) {
    return (yield call([this.notificationApiService, this.notificationApiService.Put], feedbackPath, undefined!, {
      fullname,
      phoneNumber,
      email,
      message,
    })) as ApiCallResult;
  }

  public *ChangeContainerIssuingAdditionalJobWatcher(containerIssuing: AdditionalJobModel) {
    return (yield call(
      [this.dictionaryApiService, this.dictionaryApiService.Patch],
      additionalJobsPath,
      containerIssuing.id,
      containerIssuing,
    )) as ApiCallResult;
  }

  public *LoginBitrix(email: string) {
    return (yield call([this.authApiService, this.authApiService.Post], loginBitrixPath, {
      email,
      apiKey: import.meta.env.VITE_BITRIX_API_KEY,
    })) as ApiCallResult;
  }

  public *GetDigitalLogistCarriers() {
    return (yield call([this.dictionaryApiService, this.dictionaryApiService.Get], digitalLogistCarriersBasicInfoPath)) as ApiCallResult;
  }
}

export const globalHttpService = new GlobalHttpService(dictionaryApiService, authApiService, notificationApiService);
